import React from 'react'
import styles from '../FoundersFolder/Founders.module.css'
import Footer from '../../FooterFolder/Footer';
import AOS from "aos";
import 'aos/dist/aos.css'
import { useEffect } from 'react'

export default function Founders() {
  useEffect(() => {
    AOS.init({duration: 1750})
  
  }, [])
  return (
    <>
    
    <section>
       <div className="container my-5 py-5">
   
        <div className={`${styles.bgCard} row p-5`}>
   
    <div className="col-md-12 my-3">
   <h2 className='text-center fs-2 fw-bolder position-relative mainColor'>
        Founder

         <div className="shortline mt-2"></div>
         <div className="longline"></div>
         <div className="shortline mb-2"></div>
    </h2>

<h3 className={`${styles.color} fs-4 mt-5`} data-aos='fade-right'>Pro. Dr. Ashraf EL-sayed Bastawisy</h3>
<p>Position: Responsible Director</p>
<p>Qualifying school: Bachelor of Engineering Architecture Department -Cairo University. </p>
<p>Profession: Architectural Design Consultant</p>
<p>The position of conscription: exemption final:
<p>Researcher in of Housing and building - National Center for Housing and Building.</p> 
</p>
<p><span className={`${styles.color}`}>Education and professional:</span></p>
<p>
A Bachelor of Architecture Faculty of Engineering, Cairo University,1984. 
</p>
<p>2-Diploma in planning -Cairo University's Faculty of Engineering 1985:1987. </p>
<p>3-Master in planning and architecture - Cairo University Faculty of Engineering 1999. </p>
<p>4-Doctorate in architecture and planning-- Faculty of Engineering, Cairo University, 2006. </p>
<p>5-Consultant in the design (design of public buildings - (educational establishments, sports, hotel and tourism, social and administrative)) of the Engineers Association. </p>
<p>6-Consultant in urban planning and design of the Engineers Association.</p>
 

<p><span className={`${styles.color}`}>Training courses:</span></p>
 <p> 
1-Training course in the management of projects and the Ministry of Construction and Housing 1980. 
</p>
<p>2-Training course in the management of urban planning Tokyo Japan 1992.  </p>



<p><span className={`${styles.color}`}>Professional Memberships:</span></p>
 <p>
Egyptian Syndicate of Engineers.
Egyptian Engineers Society.
</p>
<p><span className={`${styles.color}`}>Key Qualification: </span>Architectural Planning Design Management</p>



    </div> 

      </div>
       </div>
       
    </section>
   <Footer />
    </>
  )
}
